import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 16px;
  box-shadow: 0 2px 16px 0 ${({ theme }) => theme.guestCard.boxShadow};
  padding: 16px;
  margin-top: 16px;
`;

export const SeeMore = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

export const Subtitle = styled.span`
  font-size: 14px;
  line-height: 1.43;
  font-weight: 600;
  color: ${({ theme }) => theme.guestCard.titleColor};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 24px;
`;

export const Info: any = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

Info.Title = styled.span`
  font-size: 14px;
  line-height: 1.43;
  color: ${({ theme }) => theme.guestCard.infoTitle};
`;

Info.Content = styled.span`
  font-size: 14px;
  line-height: 1.43;
  color: ${({ theme }) => theme.guestCard.infoContent};
`;
